module.exports = __webpack_public_path__ + "static/img/2_1_3_2.1d0a821c.jpg";